var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 133,
    viewBox: "0 0 137 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.3426,
    cy: 66.6824,
    r: 51.9461,
    fill: "#E10000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.473,
    cy: 20.2625,
    r: 5.52618,
    fill: "#E10000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7374,
    cy: 7.36824,
    r: 7.36824,
    fill: "#E10000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.36771,
    cy: 97.9976,
    r: 3.68412,
    fill: "#E10000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.944,
    cy: 118.26,
    r: 1.84206,
    fill: "#E10000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.471,
    cy: 3.31569,
    r: 1.84206,
    fill: "#E10000"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0515,
    cy: 130.05,
    r: 2.57888,
    fill: "#E10000"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8931,
    cy: 125.997,
    r: 0.736824,
    fill: "#E10000"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.629,
    cy: 81.4192,
    r: 1.84206,
    fill: "#E10000"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.736824,
    cy: 55.2622,
    r: 0.736824,
    fill: "#E10000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.498 48.5684H78.2031C84.3438 48.5684 88.4551 52.8799 88.4551 59.292V74.0918C88.4551 80.4844 84.3438 84.7959 78.2031 84.7959H62.498C56.3594 84.7959 52.2285 80.4844 52.2285 74.0918V59.292C52.2285 52.8799 56.3594 48.5684 62.498 48.5684ZM64.3633 62.4854C63.9531 62.0732 63.8301 61.4814 63.998 60.9639C64.0684 60.7441 64.1895 60.5371 64.3633 60.3633C64.9492 59.7783 65.9004 59.7783 66.4844 60.3633L70.7285 64.6064L74.9707 60.3633C75.5566 59.7783 76.5059 59.7783 77.0918 60.3633C77.6777 60.9492 77.6777 61.8994 77.0918 62.4854L72.8496 66.7275L77.0918 70.9697C77.2891 71.167 77.4199 71.4053 77.4844 71.6562C77.6113 72.1533 77.4805 72.7031 77.0918 73.0918C76.5059 73.6768 75.5566 73.6768 74.9707 73.0918L70.7285 68.8486L66.4844 73.0918C65.9004 73.6768 64.9492 73.6768 64.3633 73.0918C63.7793 72.5059 63.7793 71.5557 64.3633 70.9697L68.6074 66.7275L64.3633 62.4854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTransaction);
export default __webpack_public_path__ + "static/media/failedTransaction.cba9a9f923b7325cc07908d3a4bd5f9e.svg";
export { ForwardRef as ReactComponent };